import React, { useState, useEffect } from "react";
import {
  CarOutlined,
  EnvironmentOutlined,
  SolutionOutlined,
  FileOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  HeatMapOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  CalculatorOutlined,
  BoxPlotFilled,
  SettingFilled,
  DashboardOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Avatar, Dropdown } from "antd";
import logo_2 from "../../assets/images/logo_2.png";
import { Outlet, useNavigate } from "react-router-dom";
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

const { Content, Sider, Header, Footer } = Layout;
const Home = () => {
  const permissions = getPermissionsFromToken();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState("3");
  const userConnected = localStorage.getItem("prenom");
  const fonctionId = parseInt(localStorage.getItem("fonction_id"));
  const [openKeys, setOpenKeys] = useState(["sub1"]);
  const navigate = useNavigate();
  useEffect(() => {
    const savedKey = localStorage.getItem("selectedKey");
    const savedOpenKeys = localStorage.getItem("openKeys");
    if (savedKey) setSelectedKey(savedKey);
    if (savedOpenKeys) setOpenKeys(JSON.parse(savedOpenKeys));
  }, []);

  const handleMenuClick = (e) => {
    setSelectedKey(e.key);
    localStorage.setItem("selectedKey", e.key);
    navigate(e.key);
  };

  const menuItems = [

    //hasPermission(permissions, "VIEW_LOGISTIQUE_DASHBOARD") && 
    {
      key: "/dashboard",
      label: "Dashboard",
      icon: <DashboardOutlined />,
    },

    ...(hasPermission(permissions, "VIEW_TAB_LOGISTIQUE")
      ? [

        {
          key: "/logistique",
          icon: <CarOutlined />,
          label: "Logistique",
          children: [
            hasPermission(permissions, "VIEW_LOGISTIQUE_CAMION") && {
              key: "/logistique/camion",
              label: "Camion",
              icon: <CarOutlined />
            },
            hasPermission(permissions, "VIEW_LOGISTIQUE_MTEC") && {
              key: "/logistique/mtec",
              label: "MTEC",
              icon: <HeatMapOutlined />
            },
            hasPermission(permissions, "VIEW_COMM_COMMANDES") && {
              key: "/logistique/commandes",
              label: "Commandes",
              icon: <ShoppingCartOutlined />,
            },
            hasPermission(permissions, "VIEW_LOGISTIQUE_CHAUFFEUR") && {
              key: "/logistique/chauffeur",
              label: "Chauffeur",
              icon: <SolutionOutlined />
            },
            hasPermission(permissions, "VIEW_LOGISTIQUE_TRAJET") && {
              key: "/logistique/trajet",
              label: "Trajet",
              icon: <EnvironmentOutlined />
            },
            hasPermission(permissions, "VIEW_LOGISTIQUE_ENTRETIEN") && {
              key: "/logistique/entretien",
              label: "Entretien",
              icon: <SettingOutlined />
            },
            hasPermission(permissions, "VIEW_LOGISTIQUE_INVENTAIRES") && {
              key: "/logistique/inventaires",
              label: "Inventaires",
              icon: <BoxPlotFilled />
            },
          ].filter(Boolean), // ✅ supprime les entrées null si pas de permission
        },
      ]
      : []),

    ...(hasPermission(permissions, "VIEW_TAB_COMMERCIALE")
      ? [
        {
          key: "/commerciale",
          icon: <FileOutlined />,
          label: "Commerciale",
          children: [
            hasPermission(permissions, "VIEW_COMM_PROSPECTION") && {
              key: "/commerciale/prospection",
              label: "Prospections",
              icon: <UserOutlined />,
            },
            hasPermission(permissions, "VIEW_COMM_CLIENTS") && {
              key: "/commerciale/clients",
              label: "Clients",
              icon: <UserOutlined />,
            },
            hasPermission(permissions, "VIEW_COMM_COTATIONS") && {
              key: "/commerciale/dotations",
              label: "Cotations",
              icon: <SolutionOutlined />,
            },
            hasPermission(permissions, "VIEW_COMM_DEVIS") && {
              key: "/commerciale/devis",
              label: "Devis",
              icon: <CalculatorOutlined />,
            },
            
            hasPermission(permissions, "VIEW_COMM_FACTURES") && {
              key: "/commerciale/facture",
              label: "Factures",
              icon: <FileTextOutlined />,
            },
            hasPermission(permissions, "VIEW_COMM_FACTURES") && {
              key: "/commerciale/echeance",
              label: "Echeance",
              icon: <FileTextOutlined />,
            },
          ].filter(Boolean),
        },
      ]
      : []),

    ...(hasPermission(permissions, "VIEW_TAB_TRANSIT")
      ? [
        {
          key: "/transit",
          icon: <FileOutlined />,
          label: "Transit",
          children: [
            hasPermission(permissions, "VIEW_TRANSIT_PROVISION") && {
              key: "/transit/provision",
              label: "Provision",
              icon: <UserOutlined />,
            },
            // hasPermission(permissions, "VIEW_TRANSIT_TASK") && {
            //   key: "/transit/task",
            //   label: "Task",
            //   icon: <UserOutlined />,
            // },
             { //hasPermission(permissions, "VIEW_TRANSIT_DOSSIER") &&
              key: "/transit/dossier",
              label: "Dossier",
              icon: <UserOutlined />,
            },
            { //hasPermission(permissions, "VIEW_TRANSIT_DOSSIER") &&
              key: "/transit/devis",
              label: "Devis",
              icon: <CalculatorOutlined />,
            },
             { //hasPermission(permissions, "VIEW_TRANSIT_DOSSIER") &&
              key: "/transit/facture",
              label: "Facture",
              icon: <FileTextOutlined />,
            },
          ].filter(Boolean),
        }
      ]
      : []),
    
    ...(hasPermission(permissions, "VIEW_TAB_UTILITAIRES")
      ? [
        {
          key: "/settings",
          icon: <SettingFilled />,
          label: "Settings",
          children: [
            hasPermission(permissions, "VIEW_UTILITAIRES_SETTINGS") && {
              key: "/settings/utilitaires",
              label: "Utilitaires",
              icon: <UserOutlined />,
            },
          ].filter(Boolean),
        },
      ]
      : []),

     ...(hasPermission(permissions, "VIEW_TAB_FINANCE")
      ? [
        {
          key: "/finance",
          icon: <SettingFilled />,
          label: "Finance",
          children: [
            hasPermission(permissions, "VIEW_FINANCE_INTERNE") && {
              key: "/finance/interne",
              label: "Caisse",
              icon: <UserOutlined />,
            },
          ].filter(Boolean),
        },
      ]
      : []),
  ];



  const userMenu = (
    <Menu>
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        onClick={() => {
          localStorage.clear();
          window.location.replace('/login');
        }}
      >
        Déconnexion
      </Menu.Item>
    </Menu>
  );

  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
    localStorage.setItem("openKeys", JSON.stringify(keys));
  };

  return (
    <div style={{ width: "100%" }}>
      <Layout style={{ minHeight: "70vh", width: "100%" }}>
        <Sider
          collapsible
          collapsed={false}
          onCollapse={(value) => setCollapsed(value)}
          style={{
            height: "100vh",
            color: "#fff",
          }}
        >
          <div
            style={{
              height: 64,
              display: "flex",
              alignItems: "center",
              justifyContent: collapsed ? "center" : "flex-start",
              padding: "0 12px",
              color: "white",
              fontSize: 18,
              fontWeight: "bold",
              gap: 8,
            }}
          >
            <img src={logo_2} style={{ height: 160 }} alt="logo" />
          </div>

          {/* ✅ On utilise maintenant menuItems au lieu de items */}
          <Menu
            className="custom-menu"
            selectedKeys={[selectedKey]}
            mode="inline"
            items={menuItems}
            onClick={handleMenuClick}
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
            style={{
              background: "#052a4cff",
              color: "#fff",
              borderRight: "none",
            }}
          />
        </Sider>

        <Layout>
          <Header
            style={{
              backgroundColor: "#011528",
              padding: "0 16px",
              display: "flex",
              alignItems: "center",
              color: "#fff",
            }}
          >
            <Dropdown overlay={userMenu} placement="bottomRight">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: 8,
                  marginLeft: "auto",
                }}
              >
                <Avatar icon={<UserOutlined />} size="medium" />
                <span>{userConnected}</span>
              </div>
            </Dropdown>
          </Header>

          <Content style={{ margin: "16px" }}>
            <div
              style={{
                padding: 24,
                minHeight: 360,
                background: "#fff",
                borderRadius: 8,
                height: "80vh",
                overflowY: "hidden",
              }}
            >
              <Outlet />
            </div>
          </Content>

          <Footer
            style={{
              textAlign: "center",
              padding: "12px 50px",
              fontSize: 16,
              backgroundColor: "#011528",
              color: "#fff",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Fleet Masoandro ©2026 | Version 1.4 |
            <span style={{ fontStyle: "italic" }}>
              Gestion simple et efficace de vos véhicules 🚚
            </span>
          </Footer>
        </Layout>
      </Layout>
    </div>
  );
};

export default Home;

// import React, { useState } from "react";
// import {
//   CarOutlined,
//   EnvironmentOutlined,
//   SolutionOutlined,
//   FileOutlined,
//   SettingOutlined,
//   UserOutlined,
//   LogoutOutlined,
//   HeatMapOutlined,
//   FileTextOutlined,
//   ShoppingCartOutlined,
//   CalculatorOutlined,
//   BoxPlotFilled,
//   SettingFilled,
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
//   RightOutlined,
// } from "@ant-design/icons";
// import { Avatar, Dropdown, Menu } from "antd";
// import logo_2 from "../../assets/images/logo_2.png";
// import { Outlet, useNavigate } from "react-router-dom";
// import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

// /* ═══════════════════════════════════════════════════════════
//    STYLES
// ═══════════════════════════════════════════════════════════ */
// const CSS = `
//   @import url('https://fonts.googleapis.com/css2?family=Figtree:wght@300;400;500;600;700&family=IBM+Plex+Mono:wght@400;600&display=swap');

//   *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
//   body { font-family: 'Figtree', sans-serif; }

//   :root {
//     --sb-w: 260px;
//     --sb-w-col: 68px;
//     --sb-bg: #ffffff;
//     --sb-border: #e8ebf0;

//     --group-text: #1a2035;
//     --group-icon-bg: #eef1f8;
//     --group-icon-color: #4b5a8a;
//     --group-open-icon-bg: #4f6ef7;
//     --group-open-icon-color: #ffffff;
//     --group-open-text: #2a3fa0;
//     --group-open-bg: #edf2ff;

//     --item-text: #5c6a8a;
//     --item-hover-bg: #f4f6fd;
//     --item-hover-text: #2a3fa0;
//     --item-active-bg: #4f6ef7;
//     --item-active-text: #ffffff;

//     --accent: #4f6ef7;
//     --accent-soft: #edf2ff;
//     --page-bg: #f0f2f9;
//     --header-border: #e8ebf0;
//     --t: 0.2s cubic-bezier(.4,0,.2,1);
//     --r-sm: 8px;
//     --r-md: 12px;
//     --r-lg: 16px;
//   }

//   /* LAYOUT */
//   .fm-layout {
//     display: flex;
//     height: 100vh;
//     overflow: hidden;
//     background: var(--page-bg);
//   }

//   /* SIDEBAR */
//   .fm-sidebar {
//     width: var(--sb-w);
//     min-width: var(--sb-w);
//     background: var(--sb-bg);
//     border-right: 1.5px solid var(--sb-border);
//     display: flex;
//     flex-direction: column;
//     height: 100vh;
//     position: relative;
//     transition: width var(--t), min-width var(--t);
//     z-index: 50;
//   }
//   .fm-sidebar.col { width: var(--sb-w-col); min-width: var(--sb-w-col); }

//   /* LOGO */
//   .fm-logo {
//     height: 64px;
//     flex-shrink: 0;
//     display: flex;
//     align-items: center;
//     padding: 0 16px;
//     gap: 10px;
//     border-bottom: 1.5px solid var(--sb-border);
//     overflow: hidden;
//   }
//   .fm-logo img { height: 34px; object-fit: contain; flex-shrink: 0; }
//   .fm-logo-brand {
//     overflow: hidden;
//     opacity: 1;
//     transition: opacity var(--t), width var(--t);
//   }
//   .col .fm-logo-brand { opacity: 0; width: 0; }
//   .fm-logo-name {
//     font-family: 'IBM Plex Mono', monospace;
//     font-size: 13px;
//     font-weight: 600;
//     color: var(--accent);
//     letter-spacing: .06em;
//     white-space: nowrap;
//     display: block;
//   }
//   .fm-logo-sub {
//     font-size: 10px;
//     color: #9ba8c5;
//     white-space: nowrap;
//     display: block;
//   }

//   /* TOGGLE */
//   .fm-toggle {
//     position: absolute;
//     right: -13px;
//     top: 72px;
//     width: 26px;
//     height: 26px;
//     background: var(--sb-bg);
//     border: 1.5px solid var(--sb-border);
//     border-radius: 50%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     cursor: pointer;
//     color: #9ba8c5;
//     font-size: 10px;
//     transition: color var(--t), box-shadow var(--t);
//     z-index: 100;
//   }
//   .fm-toggle:hover { color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }

//   /* SCROLLABLE NAV */
//   .fm-nav {
//     flex: 1;
//     overflow-y: auto;
//     overflow-x: hidden;
//     padding: 10px 10px 0;
//     scrollbar-width: thin;
//     scrollbar-color: #d8deee transparent;
//   }
//   .fm-nav::-webkit-scrollbar { width: 4px; }
//   .fm-nav::-webkit-scrollbar-thumb { background: #d8deee; border-radius: 4px; }

//   /* SECTION LABEL */
//   .fm-section-label {
//     font-size: 9px;
//     font-weight: 700;
//     letter-spacing: .18em;
//     text-transform: uppercase;
//     color: #b0bbd8;
//     padding: 14px 8px 8px;
//     white-space: nowrap;
//     transition: opacity var(--t);
//   }
//   .col .fm-section-label { opacity: 0; }

//   /* ── GROUP HEADER ── clearly distinct from children */
//   .fm-group { margin-bottom: 3px; }

//   .fm-group-header {
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     padding: 0 10px;
//     height: 46px;
//     border-radius: var(--r-md);
//     cursor: pointer;
//     user-select: none;
//     transition: background var(--t);
//   }
//   .fm-group-header:hover { background: var(--group-open-bg); }

//   .fm-group-badge {
//     width: 32px;
//     height: 32px;
//     border-radius: var(--r-sm);
//     background: var(--group-icon-bg);
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     color: var(--group-icon-color);
//     font-size: 15px;
//     flex-shrink: 0;
//     transition: background var(--t), color var(--t);
//   }
//   .fm-group-header.open .fm-group-badge,
//   .fm-group-header.has-active .fm-group-badge {
//     background: var(--group-open-icon-bg);
//     color: var(--group-open-icon-color);
//   }

//   .fm-group-label {
//     flex: 1;
//     font-size: 13.5px;
//     font-weight: 700;
//     color: var(--group-text);
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     letter-spacing: .01em;
//     transition: opacity var(--t), color var(--t);
//   }
//   .fm-group-header.open .fm-group-label,
//   .fm-group-header.has-active .fm-group-label { color: var(--group-open-text); }
//   .col .fm-group-label { opacity: 0; width: 0; }

//   .fm-group-chevron {
//     color: #b0bbd8;
//     font-size: 9px;
//     flex-shrink: 0;
//     transition: transform var(--t), opacity var(--t), color var(--t);
//   }
//   .fm-group-header.open .fm-group-chevron { transform: rotate(90deg); color: var(--accent); }
//   .col .fm-group-chevron { opacity: 0; }

//   /* ── CHILDREN ── indented, with guide line */
//   .fm-children {
//     overflow: hidden;
//     max-height: 0;
//     transition: max-height .3s cubic-bezier(.4,0,.2,1);
//     margin-left: 14px;
//     padding-left: 18px;
//     border-left: 2px solid #e8ebf4;
//     margin-bottom: 2px;
//   }
//   .fm-children.open { max-height: 500px; }
//   .col .fm-children { display: none; }

//   /* ── CHILD ITEM ── */
//   .fm-item {
//     display: flex;
//     align-items: center;
//     gap: 9px;
//     padding: 0 10px;
//     height: 36px;
//     border-radius: var(--r-sm);
//     cursor: pointer;
//     color: var(--item-text);
//     font-size: 13px;
//     font-weight: 400;
//     transition: background var(--t), color var(--t);
//     white-space: nowrap;
//     overflow: hidden;
//     margin: 2px 0;
//   }
//   .fm-item:hover { background: var(--item-hover-bg); color: var(--item-hover-text); font-weight: 500; }
//   .fm-item.active {
//     background: var(--item-active-bg);
//     color: var(--item-active-text);
//     font-weight: 600;
//   }

//   .fm-item-icon {
//     font-size: 12px;
//     flex-shrink: 0;
//     color: #9ba8c5;
//     transition: color var(--t);
//   }
//   .fm-item:hover .fm-item-icon { color: var(--accent); }
//   .fm-item.active .fm-item-icon { color: rgba(255,255,255,.8); }
//   .fm-item-label { overflow: hidden; text-overflow: ellipsis; }

//   /* COLLAPSED TOOLTIPS */
//   .fm-tip-wrap { position: relative; }
//   .fm-tip-wrap:hover .fm-tip { opacity: 1; }
//   .fm-tip {
//     position: absolute;
//     left: calc(100% + 12px);
//     top: 50%;
//     transform: translateY(-50%);
//     background: #1a2035;
//     color: #fff;
//     font-size: 12px;
//     padding: 5px 11px;
//     border-radius: 8px;
//     white-space: nowrap;
//     opacity: 0;
//     transition: opacity .15s;
//     pointer-events: none;
//     z-index: 9999;
//   }
//   .fm-tip::before {
//     content: '';
//     position: absolute;
//     right: 100%;
//     top: 50%;
//     transform: translateY(-50%);
//     border: 5px solid transparent;
//     border-right-color: #1a2035;
//   }

//   /* SIDEBAR FOOTER */
//   .fm-sb-footer {
//     flex-shrink: 0;
//     padding: 10px;
//     border-top: 1.5px solid var(--sb-border);
//   }
//   .fm-user-card {
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     padding: 8px;
//     border-radius: var(--r-md);
//     background: var(--accent-soft);
//     overflow: hidden;
//   }
//   .fm-user-info {
//     overflow: hidden;
//     flex: 1;
//     transition: opacity var(--t), width var(--t);
//   }
//   .col .fm-user-info { opacity: 0; width: 0; }
//   .fm-user-name-sb {
//     font-size: 12.5px;
//     font-weight: 600;
//     color: #1a2035;
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     display: block;
//   }
//   .fm-user-role { font-size: 10.5px; color: #7a8cb0; display: block; }

//   /* MAIN */
//   .fm-main {
//     flex: 1;
//     display: flex;
//     flex-direction: column;
//     min-width: 0;
//     height: 100vh;
//     overflow: hidden;
//   }

//   /* HEADER */
//   .fm-header {
//     height: 64px;
//     flex-shrink: 0;
//     background: #fff;
//     border-bottom: 1.5px solid var(--header-border);
//     display: flex;
//     align-items: center;
//     padding: 0 24px;
//     gap: 12px;
//   }
//   .fm-breadcrumb { flex: 1; display: flex; align-items: center; gap: 6px; }
//   .fm-bc-segment { font-size: 12.5px; color: #9ba8c5; font-weight: 500; }
//   .fm-bc-sep { color: #cdd4e8; font-size: 10px; }
//   .fm-bc-active { font-size: 14px; font-weight: 700; color: #1a2035; }

//   .fm-user-chip {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     padding: 5px 14px 5px 5px;
//     border-radius: 99px;
//     background: #f0f2f9;
//     border: 1.5px solid var(--header-border);
//     cursor: pointer;
//     transition: background var(--t), border-color var(--t);
//   }
//   .fm-user-chip:hover { background: var(--accent-soft); border-color: var(--accent); }
//   .fm-chip-name { font-size: 13px; font-weight: 600; color: #1a2035; }

//   /* CONTENT */
//   .fm-content {
//     flex: 1;
//     overflow-y: auto;
//     padding: 22px;
//     scrollbar-width: thin;
//     scrollbar-color: #d8deee transparent;
//   }
//   .fm-content-inner {
//     background: #ffffff;
//     border-radius: var(--r-lg);
//     min-height: 100%;
//     padding: 28px;
//     box-shadow: 0 1px 4px rgba(20,40,100,.06), 0 6px 24px rgba(20,40,100,.05);
//   }

//   /* FOOTER */
//   .fm-footer {
//     flex-shrink: 0;
//     height: 44px;
//     background: #fff;
//     border-top: 1.5px solid var(--header-border);
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     gap: 4px;
//     font-size: 11.5px;
//     color: #b0bbd8;
//   }
//   .fm-footer strong { color: var(--accent); font-weight: 600; }

//   .ant-avatar { background: linear-gradient(135deg, #4f6ef7, #7a92fa) !important; }
// `;

// /* NAV ITEM */
// const NavItem = ({ item, collapsed, selectedKey, onSelect }) => {
//   const active = selectedKey === item.key;
//   return (
//     <div className="fm-tip-wrap">
//       <div className={`fm-item${active ? " active" : ""}`} onClick={() => onSelect(item.key)}>
//         <span className="fm-item-icon">{item.icon}</span>
//         <span className="fm-item-label">{item.label}</span>
//       </div>
//       {collapsed && <div className="fm-tip">{item.label}</div>}
//     </div>
//   );
// };

// /* NAV GROUP */
// const NavGroup = ({ group, collapsed, selectedKey, openKeys, onSelect, onToggleGroup }) => {
//   const isOpen = openKeys.includes(group.key);
//   const hasActive = group.children?.some((c) => c.key === selectedKey);
//   const cls = `fm-group-header${isOpen ? " open" : ""}${hasActive ? " has-active" : ""}`;

//   return (
//     <div className="fm-group">
//       <div className="fm-tip-wrap">
//         <div className={cls} onClick={() => onToggleGroup(group.key)}>
//           <div className="fm-group-badge">{group.icon}</div>
//           <span className="fm-group-label">{group.label}</span>
//           <RightOutlined className="fm-group-chevron" />
//         </div>
//         {collapsed && <div className="fm-tip">{group.label}</div>}
//       </div>
//       <div className={`fm-children${isOpen ? " open" : ""}`}>
//         {group.children?.map((child) => (
//           <NavItem key={child.key} item={child} collapsed={collapsed}
//             selectedKey={selectedKey} onSelect={onSelect} />
//         ))}
//       </div>
//     </div>
//   );
// };

// /* HOME */
// const Home = () => {
//   const permissions = getPermissionsFromToken();

//   const [collapsed, setCollapsed] = useState(
//     () => localStorage.getItem("sb_collapsed") === "true"
//   );
//   const [selectedKey, setSelectedKey] = useState(
//     () => localStorage.getItem("sb_selected") || ""
//   );
//   const [openKeys, setOpenKeys] = useState(() => {
//     try { return JSON.parse(localStorage.getItem("sb_open") || "[]"); }
//     catch { return []; }
//   });

//   const userConnected = localStorage.getItem("prenom") || "Utilisateur";
//   const navigate = useNavigate();

//   const handleSelect = (key) => {
//     setSelectedKey(key);
//     localStorage.setItem("sb_selected", key);
//     navigate(key);
//   };

//   const handleToggleGroup = (key) => {
//     const next = openKeys.includes(key)
//       ? openKeys.filter((k) => k !== key)
//       : [...openKeys, key];
//     setOpenKeys(next);
//     localStorage.setItem("sb_open", JSON.stringify(next));
//   };

//   const toggleCollapse = () => {
//     const next = !collapsed;
//     setCollapsed(next);
//     localStorage.setItem("sb_collapsed", String(next));
//   };

//   const menuGroups = [
//     ...(hasPermission(permissions, "VIEW_TAB_LOGISTIQUE") ? [{
//       key: "/logistique", icon: <CarOutlined />, label: "Logistique",
//       children: [
//         hasPermission(permissions, "VIEW_LOGISTIQUE_CAMION") && { key: "/logistique/camion", label: "Camion", icon: <CarOutlined /> },
//         hasPermission(permissions, "VIEW_LOGISTIQUE_MTEC") && { key: "/logistique/mtec", label: "MTEC", icon: <HeatMapOutlined /> },
//         hasPermission(permissions, "VIEW_LOGISTIQUE_CHAUFFEUR") && { key: "/logistique/chauffeur", label: "Chauffeur", icon: <SolutionOutlined /> },
//         hasPermission(permissions, "VIEW_LOGISTIQUE_TRAJET") && { key: "/logistique/trajet", label: "Trajet", icon: <EnvironmentOutlined /> },
//         hasPermission(permissions, "VIEW_LOGISTIQUE_ENTRETIEN") && { key: "/logistique/entretien", label: "Entretien", icon: <SettingOutlined /> },
//         hasPermission(permissions, "VIEW_LOGISTIQUE_INVENTAIRES") && { key: "/logistique/inventaires", label: "Inventaires", icon: <BoxPlotFilled /> },
//       ].filter(Boolean),
//     }] : []),
//     ...(hasPermission(permissions, "VIEW_TAB_COMMERCIALE") ? [{
//       key: "/commerciale", icon: <FileOutlined />, label: "Commerciale",
//       children: [
//         hasPermission(permissions, "VIEW_COMM_PROSPECTION") && { key: "/commerciale/prospection", label: "Prospections", icon: <UserOutlined /> },
//         hasPermission(permissions, "VIEW_COMM_CLIENTS") && { key: "/commerciale/clients", label: "Clients", icon: <UserOutlined /> },
//         hasPermission(permissions, "VIEW_COMM_COTATIONS") && { key: "/commerciale/dotations", label: "Cotations", icon: <SolutionOutlined /> },
//         hasPermission(permissions, "VIEW_COMM_DEVIS") && { key: "/commerciale/devis", label: "Devis", icon: <CalculatorOutlined /> },
//         hasPermission(permissions, "VIEW_COMM_COMMANDES") && { key: "/commerciale/commandes", label: "Commandes", icon: <ShoppingCartOutlined /> },
//         hasPermission(permissions, "VIEW_COMM_FACTURES") && { key: "/commerciale/facture", label: "Factures", icon: <FileTextOutlined /> },
//       ].filter(Boolean),
//     }] : []),
//     ...(hasPermission(permissions, "VIEW_TAB_TRANSIT") ? [{
//       key: "/transit", icon: <FileOutlined />, label: "Transit",
//       children: [
//         hasPermission(permissions, "VIEW_TRANSIT_PROVISION") && { key: "/transit/provision", label: "Provision", icon: <UserOutlined /> },
//         hasPermission(permissions, "VIEW_TRANSIT_TASK") && { key: "/transit/task", label: "Task", icon: <UserOutlined /> },
//         { key: "/transit/dossier", label: "Dossier", icon: <UserOutlined /> },
//       ].filter(Boolean),
//     }] : []),
//     ...(hasPermission(permissions, "VIEW_TAB_UTILITAIRES") ? [{
//       key: "/settings", icon: <SettingFilled />, label: "Settings",
//       children: [
//         hasPermission(permissions, "VIEW_UTILITAIRES_SETTINGS") && { key: "/settings/utilitaires", label: "Utilitaires", icon: <UserOutlined /> },
//       ].filter(Boolean),
//     }] : []),
//   ];

//   const breadcrumb = (() => {
//     for (const g of menuGroups) {
//       const child = g.children?.find((c) => c.key === selectedKey);
//       if (child) return { group: g.label, page: child.label };
//     }
//     return { group: null, page: "Tableau de bord" };
//   })();

//   const userMenu = (
//     <Menu items={[{
//       key: "logout", icon: <LogoutOutlined />, label: "Déconnexion", danger: true,
//       onClick: () => { localStorage.clear(); window.location.replace('/login'); },
//     }]} />
//   );

//   return (
//     <>
//       <style>{CSS}</style>
//       <div className="fm-layout">

//         {/* SIDEBAR */}
//         <aside className={`fm-sidebar${collapsed ? " col" : ""}`}>
//           <div className="fm-logo">
//             <img src={logo_2} alt="Fleet" />
//             <div className="fm-logo-brand">
//               <span className="fm-logo-name">FLEET</span>
//               <span className="fm-logo-sub">Masoandro · v1.0</span>
//             </div>
//           </div>

//           <div className="fm-toggle" onClick={toggleCollapse}>
//             {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//           </div>

//           <nav className="fm-nav">
//             <div className="fm-section-label">Menu principal</div>
//             {menuGroups.map((group) => (
//               <NavGroup
//                 key={group.key}
//                 group={group}
//                 collapsed={collapsed}
//                 selectedKey={selectedKey}
//                 openKeys={openKeys}
//                 onSelect={handleSelect}
//                 onToggleGroup={handleToggleGroup}
//               />
//             ))}
//             <div style={{ height: 12 }} />
//           </nav>

//           <div className="fm-sb-footer">
//             <div className="fm-user-card">
//               <Avatar icon={<UserOutlined />} size={34} />
//               <div className="fm-user-info">
//                 <span className="fm-user-name-sb">{userConnected}</span>
//                 <span className="fm-user-role">Connecté</span>
//               </div>
//             </div>
//           </div>
//         </aside>

//         {/* MAIN */}
//         <div className="fm-main">
//           <header className="fm-header">
//             <div className="fm-breadcrumb">
//               {breadcrumb.group && (
//                 <><span className="fm-bc-segment">{breadcrumb.group}</span>
//                 <span className="fm-bc-sep">›</span></>
//               )}
//               <span className="fm-bc-active">{breadcrumb.page}</span>
//             </div>
//             <Dropdown overlay={userMenu} placement="bottomRight" trigger={["click"]}>
//               <div className="fm-user-chip">
//                 <Avatar icon={<UserOutlined />} size={28} />
//                 <span className="fm-chip-name">{userConnected}</span>
//               </div>
//             </Dropdown>
//           </header>

//           <main className="fm-content">
//             <div className="fm-content-inner">
//               <Outlet />
//             </div>
//           </main>

//           <footer className="fm-footer">
//             <strong>Fleet Masoandro</strong> ©2025 &nbsp;·&nbsp; v1.0 &nbsp;·&nbsp;
//             Gestion simple et efficace de vos véhicules 🚚
//           </footer>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Home;